import PropTypes from 'prop-types';

import {displayFormModal} from '@modules/clipConfiguration/utils/forms/common/formHelpers';

export const ClipConfigurationAddModalContent = (props, title, model, form) => {
    return displayFormModal(props, title, model, form, {});
};

ClipConfigurationAddModalContent.propTypes = {
    Modal: PropTypes.object.isRequired,
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
        params: PropTypes.shape({
            id: PropTypes.number,
        }),
    }),
};

export default ClipConfigurationAddModalContent;
